import { Fragment, useEffect } from 'react';
import { useCookies } from "react-cookie";
import { Text } from '../../FormControls/Text';
import { List } from '../../FormControls/List';
import { Stack } from '../../FormControls/Stack';
import { Input } from '../../FormControls/Input';

import { ScreenControl } from '../ScreenControl';
import { useDispatch, useSelector } from 'react-redux';
import {
    setAccountType, setAccountCurrency, setAccountNumber,
    setAccountName, setNit, registerBank, retrieveBanksDetails
} from '../../../../main/slices/bankSlice';
import { setStoreId } from '../../../../main/slices/bussinessSlice';
import { LoadingComponent } from '../../LoadingComponent';
import { useState } from 'react';
import { registerBitpos } from '../../../../main/slices/userSlice';

const AccountTypeSelector = ({ children, onChange, accountType, accountCurrency, types, currencys }) => {

    return (
        <Fragment>
            {/* LEGEND */}
            {children}

            {(types.length && currencys.length) ?
                <>
                    {/* ACCOUNT TYPE */}
                    <Stack flex={{ flexDirection: "column" }}>
                        <Text classes={["annotation"]}> Tipo de cuenta </Text>
                        <List
                            items={types}
                            def={accountType}
                            keys={{ img: "logo", text: "value", id: "id" }}
                            onSelect={(s) => onChange("accountType", s)}
                        />
                    </Stack>

                    {/* BANK ACCOUNT CURRENCY */}
                    <Stack flex={{ flexDirection: "column" }}>
                        <Text classes={["annotation"]}> Moneda </Text>
                        <List
                            items={currencys}
                            def={accountCurrency}
                            keys={{ img: "logo", text: "value", id: "id" }}
                            onSelect={(s) => onChange("accountCurrency", s)}
                        />
                    </Stack></>
                : <LoadingComponent />
            }
        </Fragment>
    )
}

const BankAccountDetails = ({ children, onChange, accountName, accountNumber, nit, swiftCode }) => {

    return (
        <Fragment>

            {/* LEGEND */}
            {children}

            {/* BANK ACCOUNT INFORMATION */}
            <Stack flex={{ flexDirection: "column" }}>
                <Input attributes={{ value: accountName }} type="text" classes={["marginTB1em"]}
                    onChange={({ target }) => onChange("accountName", target.value)} placeHolder="Nombre de la cuenta"
                />
                <Input attributes={{ value: accountNumber }} type="number" classes={["marginTB1em"]}
                    onChange={({ target }) => onChange("accountNumber", target.value)} placeHolder="Número de cuenta"
                />
                {/* <Input attributes={{ value: swiftCode }} type="text" classes={["marginTB1em"]}
                    onChange={({ target }) => onChange("swiftCode", target.value)} placeHolder="Código SWIFT"
                /> */}
                <Input attributes={{ value: nit }} type="text" classes={["marginTB1em"]}
                    onChange={({ target }) => onChange("nit", target.value)} placeHolder="NIT"
                />
            </Stack>
        </Fragment>
    )
}

const ScreenLegend = () => (
    <Stack flex={{ flexDirection: "column" }}>
        <Text classes={["subtitle"]}> Agreguemos tu cuenta bancaria </Text>
        <Text classes={["title"]}> Detalles de la cuenta </Text>
    </Stack>
)

export const FiatPayment = ({ path }) => {

    const [currencys, setCurrencys] = useState([]);
    const [cookies] = useCookies(["token", "u"]);
    const [types, setTypes] = useState([]);

    const state = useSelector(({ bank }) => bank);
    const dispatch = useDispatch();

    const handleChange = (key, value) => {
        if (key === "accountCurrency") dispatch(setAccountCurrency({ value, error: !value }));
        else if (key === "accountNumber") dispatch(setAccountNumber({ value, error: !value }));
        else if (key === "accountType") dispatch(setAccountType({ value, error: !value }));
        else if (key === "accountName") dispatch(setAccountName({ value, error: !value }));
        // else if (key === "swiftCode") dispatch(setSwiftCode({ value, error: !value }));
        else if (key === "nit") dispatch(setNit({ value, error: !value }));
    }

    const submitData = async () => {
        const { response } = await dispatch(registerBank({
            "id": decodeURIComponent(cookies.token),
            "u": decodeURIComponent(cookies.u)
        })).unwrap();
        if (response.ok === true) return await submitBitpos();
        else return false;
    }

    const submitBitpos = async () => {
        const { response } = await dispatch(registerBitpos({ "storeID": cookies["Store"] })).unwrap();
        if (!response.error && response.ok === true) {dispatch(setStoreId(response.store)); return true;}
        else return false;
    }

    useEffect(() => {

        dispatch(retrieveBanksDetails()).unwrap().then(({ response, statusCode }) => {
            if (statusCode === 200) {
                setCurrencys(response.currencys);
                setTypes(response.types);
            }
            else console.log(response, statusCode);
        }).catch((e) => false)

    }, [dispatch]);

    const route = (path) => {
        // FOR THE PATH "phone"
        if (path === "account") return {
            index: { fw: -1 },          // IF fw = -1, STAYS IN THE CURRENT SCREEN TRIGGER BY THE FORWARD BUTTON
            path: "account-details",    // THE NEXT PATH THE COMPONENT IS GOING TO RENDER
            disabled: state.accountType.error || state.accountCurrency.error
        }
        // FOR THE PATH "utp"
        else if (path === "account-details") return {
            index: { bw: -1 },  // IF bw = -1, STAYS IN THE CURRENT SCREEN TRIGGER BY THE BACKWARD BUTTON
            path: "account",    // THE NEXT PATH THE COMPONENT IS GOING TO RENDER
            disabled: (state.accountName.error || state.accountNumber.error
                // || state.swiftCode.error 
                || state.nit.error),
            beforeSubmit: () => submitData(),
        }
    }

    return (
        <Fragment>

            {/* ACCOUNT COMPONENT */}
            {path === "account" && <AccountTypeSelector
                types={types}
                currencys={currencys}
                onChange={handleChange}
                accountType={state.accountType.value}
                accountCurrency={state.accountCurrency.value}
            >
                <ScreenLegend></ScreenLegend>
            </AccountTypeSelector>}

            {/* ACCOUNT COMPONENT */}
            {path === "account-details" && <BankAccountDetails
                nit={state.nit.value}
                onChange={handleChange}
                swiftCode={"1"}
                accountName={state.accountName.value}
                accountNumber={state.accountNumber.value}
            >
                <ScreenLegend></ScreenLegend>
            </BankAccountDetails>}

            {/* CONTROLLER */}
            <ScreenControl {...route(path)}>
            </ScreenControl>

        </Fragment >
    )
}